import React from 'react';
import { useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { GET_AI_ANALYSIS_STEPS } from '../../GraphQL/AIAnalysis/queries';
import { setData } from '../../App/Slices/AIAnalysis';
import AIAnalysisMenu from './AIAnalysisMenu';
import GraphQLWrapper from '../UI/GraphQLWrapper/GraphQLWrapper';

export default function AIAnalysisMenuDataCollector() {
  const dispatch = useDispatch();

  const { loading, error } = useQuery(GET_AI_ANALYSIS_STEPS, {
    onCompleted: (data) => {
      dispatch(setData(data.ragAnalysisSchemaFindMany || []));
    },
    onError: (error) => {
      console.error('Error fetching AI analysis data:', error);
      window.flash('Error loading AI analysis data', 'error');
    },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <GraphQLWrapper
      loading={loading}
      error={error}
      component={<AIAnalysisMenu />}
    />
  );
}
